import { useSelector } from 'react-redux'
import useCurrentUserProp from 'hooks/useCurrentUserProp'

export default function useCurrentUserEntity(entityName, pluralizedEntityName = null) {
  const entityId = useCurrentUserProp(entityName)
  const selectedEntities = useSelector(({ entities }) => entities[pluralizedEntityName || `${entityName}s`])

  return selectedEntities[entityId]
}
